import styled from "styled-components";
import theme from "../../Styles/theme";


export const Container = styled.div`


`;


export const HandleInput = styled.div`

    display: flex;
    align-items: center;
    justify-content:space-around;
`;

export const HandleButton = styled.div`
    margin:auto;
    margin-top:2vh;
    width:50%;
`;


export const AtivarDiv = styled.div`

    width:100%;
    display: flex;
    align-items: center;
    justify-content:center;

`;

export const Label = styled.label`
display: flex;
    align-items: center;
    justify-content:center;
   
    cursor: pointer;

    margin-top:2vh;
`;


export const AtivoSpan = styled.span`
    font-size: max(1vw, 12px);
    color:${theme.colors.dark};
`;